import { render, staticRenderFns } from "./consumerItems.vue?vue&type=template&id=ed61b806&"
import script from "./consumerItems.vue?vue&type=script&lang=js&"
export * from "./consumerItems.vue?vue&type=script&lang=js&"
import style0 from "./consumerItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports